import { useRoute, useRuntimeConfig, useHead, useSeoMeta } from '#imports';

export interface MetaParams {
  title: Ref<string>;
  isIndexed?: Ref<boolean>; // Define "isIndexed" via definePageMeta({ isIndexed: false });. This will be respected in the Sitemap too.
  description?: Ref<string>;
  ogImage?: Ref<string | undefined>;
  ogType?: Ref<string>;
  canonicalUrl?: Ref<string>;
}

export const getHeader = (
  meta: MetaParams = {
    title: ref(''),
  },
  options: {
    showCanonical: boolean;
  } = {
    showCanonical: false,
  }
) => {
  const $route = useRoute();
  const $config = useRuntimeConfig();

  const isIndex = () => {
    if ($route.meta?.isIndexed !== undefined && meta.isIndexed?.value !== undefined) {
      console.error(
        `You have defined "isIndexed" in "definePageMeta" and in "getHeader". Using version from "definePageMeta". Path: "${$route.path}"`
      );
    }
    if ($route.meta?.isIndexed !== undefined) return $route.meta?.isIndexed;
    return meta.isIndexed?.value;
  };

  const canonicalUrl = () => {
    if (isIndex() === false && !options.showCanonical) {
      return undefined;
    }
    if (meta.canonicalUrl?.value) return meta.canonicalUrl.value;
    return new URL($route.path, $config.public.baseUrl as string).toString();
  };

  useHead(() => {
    const canonical = canonicalUrl();
    if (!canonical) return {};

    return {
      link: [
        {
          rel: 'canonical',
          href: canonical,
        },
      ],
    };
  });

  const ogImage = () => {
    if (!meta.ogImage?.value) return undefined;
    return new URL(meta.ogImage?.value, $config.public.baseUrl).href;
  };

  const robots = () => (isIndex() === false ? 'noindex, follow' : 'index, follow');

  const title = () => meta.title.value;

  const description = () => meta.description?.value;

  useSeoMeta({
    title,
    robots,
    description,
    ogUrl: canonicalUrl,
    ogTitle: title,
    // @ts-expect-error
    ogType: () => (meta.ogType ? meta.ogType.value : 'website'),
    ogImage,
    ogDescription: description,
  });
};
